/* eslint object-curly-newline:0 */
/* eslint no-empty-pattern:0 */
import Vue from 'vue';
import Vuex from 'vuex';
import randomMc from 'random-material-color';
import * as turf from '@turf/turf';
import loadingHandler from '../../services/loadingHandler';
import errorHandler from '../../services/errorHandler';
import { ParkingLotsApi } from '../../api';
import getTextColor from '../../services/utils/getTextColor';
import variables from './variables';
import metrics from './metrics';
import app from './app';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    parkingLots: [],
    parkingLotDetail: {},
    updateParkingSpaceViaSocket: null,
    colors: {},
  },
  mutations: {
    SAVE_PARKING_LOTS(state, payload) {
      let colorPreset = ["#1ab2e7", "#ff065a", "#5ab465", "#FDD835", "#8E24AA", "#009688", "#BDBDBD", "#CDDC39", "#FB8C00"];
      payload.parkingLots.map((parkingLot, index) => {
        parkingLot.parking_spaces = [];
        parkingLot.visualIndex = index + 1;
        let color;

        if (!state.colors[parkingLot.id]) {
          if (parkingLot.visualIndex <= colorPreset.length) {
            color = colorPreset[parkingLot.visualIndex - 1]
          } else {
            color = randomMc.getColor({ shades: ['400', '500', '600'] });
          }
          state.colors[parkingLot.id] = color;
        } else {
          color = state.colors[parkingLot.id];
        }
        parkingLot.trailingIcons = [];
        if (parkingLot.shape) {
          parkingLot.center = {
            id: parkingLot.id,
            geoJson: turf.center(parkingLot.shape),
            innerHTML: index + 1,
            backgroundColor: color,
            textColor: getTextColor(color),
            className: 'bc number-avatar as-marker',
            eventListener: true,
          };
          parkingLot.layer = {
            id: `layer-${parkingLot.id}`,
            type: 'line',
            source: {
              type: 'geojson',
              data: {
                type: 'Feature',
                geometry: parkingLot.shape,
              },
            },
            layout: {},
            paint: {
              'line-color': color,
              'line-opacity': 1,
              'line-width': 2,
            },
          };
        } else {
          parkingLot.trailingIcons.push({
            name: 'warning',
            color: 'warning',
            tooltipMsg: 'Diesem Standort wurde noch keine geografische Fläche zugeordnet.',
          });
        }
        const stats = Object.keys(parkingLot.current_usage)
          .map(type => parkingLot.current_usage[type]);
        stats.forEach((stat) => {
          switch (stat.type) {
            case 'handicapped':
              parkingLot.trailingIcons.push({
                name: 'accessible',
              });
              break;
            case 'charging':
              parkingLot.trailingIcons.push({
                name: 'ev_station',
              });
              break;
            case 'woman':
              parkingLot.trailingIcons.push({
                name: 'child_friendly',
              });
              break;
            default:
              break;
          }
        });
        parkingLot.parkingSpaceNumber = stats
          .reduce((total, { total_parking_spaces }) => total + total_parking_spaces, 0);
        parkingLot.parkingSpaceOccupied = stats
          .reduce((total, { occupied_spaces }) => total + occupied_spaces, 0);
        parkingLot.backgroundColor = color;
        parkingLot.textColor = getTextColor(color);
      });
      if (payload.single) {
        const [parkingLot] = payload.parkingLots;
        state.parkingLotDetail = parkingLot;
        state.parkingLotDetail.parking_spaces = [];
      } else {
        state.parkingLots = payload.parkingLots;
      }
      loadingHandler.setLoading(false);
    },
    SET_PARKING_LOT_DETAIL(state, parkingLot) {
      state.parkingLotDetail = parkingLot;
    },
    SAVE_PARKING_SPACES(state, parkingSpaces) {
      parkingSpaces.map((parkingSpace, index) => {
        let parkingSpaceOccupied;
        if (parkingSpace.current_state === 'free') {
          parkingSpaceOccupied = false;
        } else {
          parkingSpaceOccupied = true;
        }
        let color;
        if (parkingSpaceOccupied) {
          color = variables.state.colors.parkingSpace.occupied;
        } else {
          color = variables.state.colors.parkingSpace.available;
        }
        parkingSpace.backgroundColor = color;
        parkingSpace.textColor = getTextColor(color);
        parkingSpace.trailingIcons = [];
        parkingSpace.occupied = parkingSpaceOccupied;
        if (parkingSpace.type === 'charging') {
          parkingSpace.trailingIcons.push({
            name: 'ev_station',
          });
        } else if (parkingSpace.type === 'handicapped') {
          parkingSpace.trailingIcons.push({
            name: 'accessible',
          });
        } else if (parkingSpace.type === 'woman') {
          parkingSpace.trailingIcons.push({
            name: 'child_friendly',
          });
        } else {
          parkingSpace.trailingIcons.push({
            name: 'local_parking',
          });
        }
        parkingSpace.layer = {
          id: `layer-space-${parkingSpace.id}`,
          type: 'fill',
          source: {
            type: 'geojson',
            data: {
              type: 'Feature',
              geometry: parkingSpace.shape,
            },
          },
          paint: {
            'fill-color': color,
            'fill-opacity': 1,
            'fill-outline-color': '#000',
          },
          eventListener: true,
        };
        let icon;
        if (parkingSpace.type === 'charging') icon = 'ev_station';
        else if (parkingSpace.type === 'handicapped') icon = 'accessible';
        else if (parkingSpace.type === 'woman') icon = 'child_friendly';
        else icon = 'local_parking';
        parkingSpace.center = {
          id: parkingSpace.id,
          geoJson: turf.center(parkingSpace.shape),
          innerHTML: `
            <span>${index + 1}</span> ${icon !== null ? `<i class="v-icon material-icons theme--light">${icon}</i>` : ''}
          `,
          backgroundColor: color,
          textColor: '#fff',
          className: 'map__marker-icon as-space',
          eventListener: true,
        };
      });
      state.parkingLotDetail.parking_spaces = parkingSpaces;
      loadingHandler.setLoading(false);
    },
  },
  actions: {
    GET_ALL_PARKING_LOTS({ commit }) {
      loadingHandler.setLoading(true);
      ParkingLotsApi.getParkingLots()
        .then((resp) => {
          commit('SAVE_PARKING_LOTS', {
            parkingLots: resp.data,
            single: false,
          });
        })
        .catch((err) => {
          console.error(err);
        });
    },
    POST_PARKING_LOT({ dispatch }, payload) {
      loadingHandler.setLoading(true);
      ParkingLotsApi.postParkingLot(payload)
        .then(() => {
          setTimeout(() => {
            dispatch('GET_ALL_PARKING_LOTS');
          }, 500);
        })
        .catch((err) => {
          errorHandler.showError(err);
        });
    },
    GET_PARKING_LOT_BY_ID({ commit }, id) {
      loadingHandler.setLoading(true);
      return new Promise((resolve) => {
        ParkingLotsApi.getParkingLotById(id)
          .then((resp) => {
            commit('SAVE_PARKING_LOTS', {
              parkingLots: [resp.data],
              single: true,
            });
            resolve(resp);
          })
          .catch((err) => {
            errorHandler.showError(err);
          });
      });
    },
    PATCH_PARKING_LOT_BY_ID({}, { id, payload }) {
      return new Promise((resolve) => {
        ParkingLotsApi.patchParkingLot(id, payload)
          .then((resp) => {
            resolve(resp);
          });
      });
    },
    GET_PARKING_SPACES_OF_PARKING_LOT({ commit }, id) {
      loadingHandler.setLoading(true);
      ParkingLotsApi.getParkingSpaceByParkingLotId(id)
        .then((resp) => {
          commit('SAVE_PARKING_SPACES', resp.data);
        })
        .catch((err) => {
          errorHandler.showError(err);
        });
    },
    POST_PARKING_SPACE({ dispatch }, payload) {
      loadingHandler.setLoading(true);
      ParkingLotsApi.postParkingSpace(payload.parking_lot_id, payload)
        .then(() => {
          setTimeout(() => {
            dispatch('GET_PARKING_SPACES_OF_PARKING_LOT', payload.parking_lot_id);
          }, 500);
        })
        .catch((err) => {
          errorHandler.showError(err);
        });
    },
    DELETE_PARKING_LOT({}, id) {
      return new Promise((resolve) => {
        ParkingLotsApi.deleteParkingLot(id)
          .then((resp) => {
            resolve(resp);
          });
      });
    },
    DELETE_PARKING_SPACE({ dispatch }, { parkingLotId, parkingSpaceId }) {
      return new Promise((resolve) => {
        ParkingLotsApi.deleteParkingSpace(parkingLotId, parkingSpaceId)
          .then((resp) => {
            dispatch('GET_PARKING_SPACES_OF_PARKING_LOT', parkingLotId);
            resolve(resp);
          });
      });
    },
    UPDATE_PARKING_SPACE({ dispatch }, { parkingLotId, parkingSpaceId, payload }) {
      return new Promise((resolve) => {
        ParkingLotsApi.patchParkingSpace(parkingLotId, parkingSpaceId, payload)
          .then((resp) => {
            dispatch('GET_PARKING_SPACES_OF_PARKING_LOT', parkingLotId);
            resolve(resp);
          });
      });
    },
    PARKING_LOT_SOCKET({ state }, parkingLotId) {
      const parkingLotSocketsConnected = app.state.singleParkingLotSocketConnected;
      const isInArr = parkingLotSocketsConnected.indexOf(parkingLotId);
      if (parkingLotId && isInArr === -1) {
        app.state.singleParkingLotSocketConnected.push(parkingLotId);
        ParkingLotsApi.parkingLotSocket(parkingLotId).events.on('parking_state', (msg) => {
          state.parkingLotDetail.parking_spaces.map((space) => {
            if (space.id === msg.parking_space_id && msg.event_type === 'occupied') {
              space.occupied = true;
              space.backgroundColor = variables.state.colors.parkingSpace.occupied;
              space.textColor = getTextColor(variables.state.colors.parkingSpace.occupied);
              space.center.backgroundColor = space.backgroundColor;
              state.updateParkingSpaceViaSocket = -1;
              setTimeout(() => {
                state.updateParkingSpaceViaSocket = null;
              }, 150);
            } else if (space.id === msg.parking_space_id && msg.event_type === 'free') {
              space.occupied = false;
              space.backgroundColor = variables.state.colors.parkingSpace.available;
              space.textColor = getTextColor(variables.state.colors.parkingSpace.available);
              space.center.backgroundColor = space.backgroundColor;
              state.updateParkingSpaceViaSocket = -1;
              setTimeout(() => {
                state.updateParkingSpaceViaSocket = null;
              }, 150);
            }
          });
        });
      } else {
        const getNewStats = () => {
          metrics.dispatch('GET_CURRENT_USAGE');
          metrics.dispatch('GET_DAILY_STATS');
          metrics.dispatch('GET_WORKLOAD');
        };

        if (app.state.allParkingLotSocketConnected === false) {
          app.state.allParkingLotSocketConnected = true;
          ParkingLotsApi.parkingLotSocket().events.on('parking_state', (msg) => {
            // checks if this is the latest event, which is defined by having a `started` date but not an `ended` date.
            if (!!msg.event_started && !msg.event_ended) {
              metrics.dispatch('ADD_PARKING_EVENT', msg);
              getNewStats();
            }
            state.parkingLots.map((parkingLot) => {
              if (parkingLot.id === msg.parking_lot_id && msg.event_type === 'occupied' && msg.event_ended === null) {
                parkingLot.parkingSpaceOccupied += 1;
              } else if (parkingLot.id === msg.parking_lot_id && msg.event_type === 'free' && msg.event_ended === null) {
                parkingLot.parkingSpaceOccupied -= 1;
              }
            });
          });
        }
      }
    },
    CLOSE_PARKING_LOT_SOCKET({}, parkingLotId) {
      if (parkingLotId) {
        ParkingLotsApi.parkingLotSocket(parkingLotId).events.leave();
        ParkingLotsApi.parkingLotSocket(parkingLotId).socket.disconnect();
      } else {
        ParkingLotsApi.parkingLotSocket().events.leave();
        ParkingLotsApi.parkingLotSocket().socket.disconnect();
      }
    },
  },
});
